import Popper from 'popper.js';

export default {
  name: 'MToolTip',
  props: {
    placement: {
      type: String,
      default: 'right',
    },
  },
  data: () => ({
    show: false,
  }),
  methods: {
    toggleTooltip() {
      if (this.show) {
        this.show = false;
      } else {
        this.show = true;
        // eslint-disable-next-line no-new
        new Popper(this.$refs.btnRef, this.$refs.tooltipRef, {
          placement: this.placement,
        });
      }
    },
    setupEventHandler() {
      const clickHandler = (e) => {
        const isTooltip = (e.target === this.$refs.btnRef || e.target === this.$refs.tooltipRef);
        if (this.show && !isTooltip) {
          this.show = false;
        }
      };
      document.addEventListener('click', clickHandler);
      this.$once('hook:destroyed', () => {
        document.removeEventListener('click', clickHandler);
      });
    },
  },
  created() {
    this.setupEventHandler();
  },
};
